import { useController } from '../../../contexts';
import { useContentFieldPath } from '../fieldPaths';
import { useValidateClauseContent } from '../../useValidateClauseContent';

export const useContentController = () => {
  const fieldPath = useContentFieldPath();
  const validate = useValidateClauseContent();
  return useController({
    name: fieldPath,
    rules: { validate },
  });
};
